import induvidualcare from '../assets/images/induvidual_care.jpg'
import skill from '../assets/images/skill_development_class.jpg'
import cctv from '../assets/images/cctv.jpg'
import chess from '../assets/images/chess.jpg'

export const facilitiesHome = [
    {
        image:induvidualcare,
        alt:"",
        topic:"Individual Care"
    },
    
    {
        image:skill,
        alt:"",
        topic:"Skill Development Classes"
    },
    {
        image:chess,
        alt:"",
        topic:"Chess Tournament"
    },
    {
        image:chess,
        alt:"",
        topic:"Science Labs"
    },
    
    {
        image:chess,
        alt:"",
        topic:"Computer Lab"
    },
    {
        image:cctv,
        alt:"",
        topic:"CCTV Security"
    },

] 